var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 copyright text-justify mb-4",style:(`color: ${_vm.fontColor} !important; font-size: smaller;`)},[_vm._v("\n      "+_vm._s(_vm.disclaimerContent)+"\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }